import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Button, FormHelperText, TextField, Typography } from '@material-ui/core';
import useMounted from '../../../hooks/useMounted';
import PropTypes from 'prop-types';
import { useState } from 'react';

const PasswordRecoveryJWT = (props) => {
  const { resetPassword } = props;
  const mounted = useMounted();
  const [successReset, setSuccessReset] = useState(false);

  return (
    successReset ? (
      <>
        <Typography>Foi enviado um email com as intruções para repor a palavra passe.</Typography>
        <Typography>Verifica a tua conta de email.</Typography>
      </>
    ) : (
      <Formik
        initialValues={{
          email: '',
          submit: null
        }}
        validationSchema={Yup
          .object()
          .shape({
            email: Yup
              .string()
              .email('Email Inválido')
              .max(255)
              .required('Email obrigatório'),
          })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
          try {
            const data = await resetPassword(values.email);
            if (mounted.current) {
              if (!data.error) {
                setSuccessReset(true);
                setStatus({ success: true });
                setSubmitting(false);
              } else if (data.error) {
                setStatus({ success: false });
                setErrors({ submit: data.message });
                setSubmitting(false);
              } else {
                setStatus({ success: false });
                setErrors({ submit: 'Problemas ao efetuar pedido. Por favor, tente mais tarde.' });
                setSubmitting(false);
              }
            }
          } catch (err) {
            console.error(err, err.Error);
            if (mounted.current) {
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
          <form
            noValidate
            onSubmit={handleSubmit}
          >
            <TextField
              autoFocus
              error={Boolean(touched.email && errors.email)}
              fullWidth
              helperText={touched.email && errors.email}
              label="Email"
              margin="normal"
              name="email"
              onBlur={handleBlur}
              onChange={handleChange}
              type="email"
              value={values.email}
              variant="outlined"
            />
            {errors.submit && (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>
                  {errors.submit}
                </FormHelperText>
              </Box>
            )}
            <Box sx={{ mt: 2 }}>
              <Button
                color="primary"
                disabled={isSubmitting}
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                Repor palavra-passe
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    )
  );
};

PasswordRecoveryJWT.propTypes = {
  resetPassword: PropTypes.func
};

export default PasswordRecoveryJWT;
